import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { ArticleBoardType } from "@sellernote/shared/src/api/dto/entities/common/support";
import {
  getArticleBoardTypeString,
  getBoardHref,
} from "@sellernote/features/src/common/utils/support";
import { supportActions } from "@sellernote/shipda-kr/src/modules/support";
import { useAppSelector } from "@sellernote/shipda-kr/src/store";
import BoardCategory from "@sellernote/ui/src/sds-v1/components/board/BoardCategory";
import Loading from "@sellernote/ui/src/sds-v1/components/Loading";

export default function CategoryList({
  articleType,
}: {
  articleType: ArticleBoardType;
}) {
  const { t } = useTranslation(["support-new"]);

  const router = useRouter();
  const { id } = router.query;

  const dispatch = useDispatch();

  const { boardList } = useAppSelector((state) => {
    return {
      boardList: state.support.GET_LIST.data?.list,
    };
  });

  useEffect(() => {
    if (id) {
      fetchList();
    }

    return () => {
      dispatch(supportActions.INIT_GET_LIST({}));
    };
  }, [id, articleType]);

  if (!boardList)
    return <Loading active={!boardList} label={t("support-new:공통_로딩")} />;

  function fetchList() {
    const params = { articleType, page: 0, perPage: 10 };

    dispatch(supportActions.GET_LIST(params));
  }

  return (
    <BoardCategory
      title={getArticleBoardTypeString(articleType)}
      type="boardList"
      boardHref={getBoardHref(articleType)}
      boardList={boardList}
      currentContentsId={Number(id)}
    />
  );
}
